import ApolloClient from "apollo-boost";

const apolloUri = process.env.VUE_APP_APOLLOURI || "http://localhost:4000";

const apolloClient = new ApolloClient({
  uri: `${apolloUri}`
});

export { apolloClient };
